import { consumeAuthDenialMessage } from '@Core/Auth/authDenial'
import { CookiesStorage } from '@Core/Communication/GlobalStore/CookiesStorage/CookiesStorage'
import { useAuth } from '@Core/Hooks/useAuth'
import { RoutesPaths } from '@Entry/Common/RoutesPaths'
import { OAuthProvider } from 'firebase/auth'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Actions, LoginNotice } from './Login.styles'
import { BadgeFace, LoginBadge } from './LoginBadge'
import { LoginForm } from './LoginForm'

/**
 * E-mail and password sign-in for authorized exceptions (third parties,
 * service accounts). Not linked from any screen: the administrator shares
 * the address. Hiding it only keeps regular users away — the API refuses
 * password sessions of anyone who is not an exception (FR-016a).
 */
export const AlternativeLogin = () => {
    const { uiAuthenticate, loading } = useAuth(
        new CookiesStorage(),
        new OAuthProvider('microsoft.com')
    )

    useEffect(() => {
        const denial = consumeAuthDenialMessage()
        if (denial) toast.error(denial)
    }, [])

    return (
        <LoginBadge>
            <BadgeFace
                title="Acesso alternativo"
                compact
                footer={<Link to={RoutesPaths.Login}>Voltar para o login</Link>}
            >
                <Actions>
                    <LoginNotice data-testid="alternative-login-notice">
                        Acesso restrito a contas autorizadas. Se você é colaborador,
                        use Entrar com Microsoft.
                    </LoginNotice>
                    <LoginForm uiAuthenticate={uiAuthenticate} loading={loading} />
                </Actions>
            </BadgeFace>
        </LoginBadge>
    )
}
